<template>
  <div class="signInDetail">
    <div class="mobileHeader">
      <p>
        <span style="margin-right: 10%"
          >WMS进仓单号：{{ list.deliveryOrdeNo }}</span
        >
      </p>
      <p>
        <span>参考单号：{{ list.orgCustomerNo }}</span>
      </p>
      <span>预计到仓时间：{{ list.estimatedDate }}</span>
    </div>
    <div class="sign-item">
      <div style="margin-bottom: 10px">
        <span style="margin-right: 10%"
          >预报总箱数：{{ list.totalBoxCount }}</span
        ><span>已收箱数：{{ list.signedBoxCount }}</span>
      </div>
      <van-form @submit="submit">
        <div>
          <span>实际到仓时间</span>
          <van-field
            readonly
            clickable
            v-model="list.actualArriveDate"
            placeholder="点击选择时间"
            :rules="[{ required: true, message: '请选择操作时间' }]"
            @click="showPicker = true"
          />
          <van-popup v-model="showPicker" position="bottom">
            <van-datetime-picker
              confirm-button-text="确定"
              cancel-button-text="取消"
              v-model="currentDate"
              type="datetime"
              @confirm="onConfirm"
              @cancel="showPicker = false"
            />
          </van-popup>
        </div>
        <div>
          <span>本次签收数量</span>
          <van-field
            v-model="list.actualBoxCount"
            type="digit"
            maxlength="10"
            :max="1000"
            placeholder="签收数量"
            :rules="[{ required: true, message: '请填写签收数量' }]"
          />
        </div>
        <div>
          <span>备注</span>
          <van-field
            v-model="list.remark"
            rows="2"
            autosize
            type="textarea"
            maxlength="200"
            placeholder="请输入备注"
            show-word-limit
          />
        </div>
        <div class="signInDetail-end">
          <van-radio-group v-model="list.isUnloadFlag" direction="horizontal">
            <van-radio shape="square" name="unload">货主自卸</van-radio>
            <van-radio shape="square" name="isUnload">仓库卸货</van-radio>
          </van-radio-group>
        </div>
        <div>
          <van-button
            class="signInDetail-receipt"
            round
            block
            type="info"
            native-type="submit"
            >确认收货</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import {
  Field,
  Toast,
  Form,
  Button,
  Popup,
  DatetimePicker,
  Uploader,
  ImagePreview,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
} from "vant";
import util from "util/date";
import { getDeliveryNo, submitSignFor } from "@/api/mobile/jy-signReceipt_api";
import { mixins } from "../mobileMixins";

export default {
  data() {
    return {
      currentDate: new Date(),
      list: {
        actualArriveDate: this.getToday(),
      },
      itemArr: ["本次签收数量"],
      showPicker: false,
    };
  },

  components: {
    [Field.name]: Field,
    [Form.name]: Form,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Uploader.name]: Uploader,
    [ImagePreview.name]: ImagePreview,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
  },

  mixins: [mixins],

  created() {
    this.init();
  },

  methods: {
    getToday() {
      var currentDate = new Date();
      var year = currentDate.getFullYear();
      var month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
      var day = ("0" + currentDate.getDate()).slice(-2);
      var hours = ("0" + currentDate.getHours()).slice(-2);
      var minutes = ("0" + currentDate.getMinutes()).slice(-2);

      var formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
      return formattedDate;
    },
    onConfirm(time) {
      this.$set(
        this.list,
        "actualArriveDate",
        util.formatDate.format(time, "yyyy-MM-dd hh:mm")
      );
      this.showPicker = false;
    },
    init() {
      this.getDeliveryNo();
    },
    getDeliveryNo() {
      const { deliveryOrdeNo } = this.$route.query;
      const data = {
        deliveryOrdeNo,
      };

      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      getDeliveryNo(data).then((res) => {
        Toast.clear();

        if (res.status === 200) {
          const { response } = res;

          try {
            response.estimatedDate = util.formatDate.format(
              new Date(response.estimatedDate),
              "yyyy-MM-dd"
            );
          } catch {}
          this.list = {
            ...response,
            actualArriveDate: this.getToday(),
          };
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    submit() {
      const that = this;
      if (!this.list.isUnloadFlag) {
        Toast("请选择卸货方式");
        return;
      }
      let {
        tfDeliveryOrderID,
        actualBoxCount,
        actualArriveDate,
        remark,
        isUnloadFlag,
        totalBoxCount,
        signedBoxCount,
      } = this.list;
      if (actualBoxCount > totalBoxCount - signedBoxCount) {
        Toast("签收数量不能大于（预报总箱数-已收箱数）");
        return;
      }
      const data = {
        isUnload: isUnloadFlag === "isUnload",
        tfDeliveryOrderID,
        actualBoxCount,
        actualArriveDate,
        remark,
      };

      Toast.loading({
        message: "签收中...",
        forbidClick: true,
      });

      submitSignFor(data).then((res) => {
        Toast.clear();

        if (res.status === 200) {
          Toast.success("签收成功");
          setTimeout(function () {
            that.$router.go(-1);
          }, 1500);
        } else {
          Toast.fail(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.signInDetail .mobileHeader {
  padding: 0 10px 15px;
  font-size: 14px;
  border-bottom: 1px solid #ccc;
}

.sign-item {
  background-color: #fbf9fe;

  .van-form {
    > div {
      display: flex;
      gap: 10px;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 10px;

      .van-cell {
        flex: 1;
        border: 1px solid #ccc;
      }
    }

    .signInDetail-end {
      justify-content: flex-end;
    }
  }

  padding: 10px;

  .signInDetail-content {
    font-size: 15px;
  }

  .signInDetail-btnBox {
    li {
      line-height: 40px;
      white-space: nowrap;
      display: flex;
      align-items: baseline;
    }

    .volume {
      min-width: 10%;
      max-width: 17%;
      height: 22px;
      line-height: 22px;
      font-size: 14px;
      border: 1px solid #ccc;
      outline: none;
      margin: 0 5px;
      padding: 0 5px;
      box-sizing: border-box;
    }

    .van-cell {
      margin-left: 10px;
      border: 1px solid #adadad;
      flex: 1;
    }
  }
}

.signInDetail-receipt {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  margin-top: 20px;
  font-size: 18px;
  border: 0;
}

.btn {
  width: 35%;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 14px;
  border: 0;
  height: 25px;
  line-height: 25px;
}

.sign-photo-box {
  margin: 5px 10px 10px;
  border: 1px solid #797979;
  box-sizing: border-box;
  padding: 10px;

  ul {
    .sign-photo-item {
      width: 30.333%;
      height: 100px;
      border: 5px solid #ccc;
      box-sizing: border-box;
      position: relative;
      float: left;
      margin: 0 4.5% 4.5% 0;
      line-height: 127px;
      overflow: hidden;

      &:nth-child(3n) {
        margin-right: 0;
      }

      .delete-icon {
        position: absolute;
        background: red;
        color: #fff;
        width: 16px;
        height: 16px;
        top: 0px;
        right: 0px;
        line-height: 16px;
        font-size: 12px;
        border-radius: 16px;
        text-align: center;
      }

      .sign-photo-item-img {
        width: auto;
        height: 100%;
      }
    }

    .sign-photo-btn {
      display: inline-block;
      vertical-align: top;
      width: 30.333%;

      .photo {
        height: 100px;
        background-color: #faf9fc;
        position: relative;

        p {
          border: 1px dashed #ccc;
          padding: 10px;
          width: 50px;
          height: 50px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          margin: 0;

          i {
            font-size: 40px;
            color: #ccc;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}

.sign-photo-save {
  padding: 0 10px;
}

::v-deep .van-icon-photo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.fl {
  flex: 1 1 0%;
  max-width: 100% !important;
}

.hidden {
  display: none;
}

@media screen and (max-width: 360px) {
  .signInDetail-btnBox {
    li {
      font-size: 14px;
    }
  }
}
</style>
